import React, {Component} from "react";
import LoginNavbar from "./LoginNavbar";
import LoginForm from "./LoginForm";
import { connect } from "react-redux";
import {userActions} from "../../../actions/user.actions";

class LoginPage extends Component {
    constructor(props) {
        super(props);
        // reset login status
        this.props.dispatch(userActions.logout());
    }

    state = {
        isError: false
    };

    handleLogin = (loginModel) => {
        const { dispatch } = this.props;
        if(loginModel.email && loginModel.password) {
            dispatch(userActions.login(loginModel.email, loginModel.password, (error) => {
                console.log(error);
                this.setState({ isError: true })
            }))
        }
    };

    render() {
        return(
            <div>
                <LoginNavbar />
                <LoginForm onLogin={this.handleLogin} validationError={ this.state.isError }/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { loggingIn } = state.authenticationReducer;
    return {
        loggingIn
    }
};

export default connect(mapStateToProps)(LoginPage);
